import React from 'react';

import { useCurrentUserPermissions } from 'src/hooks/user';
import { NotFoundErrorPage } from 'src/pages/not-found';

import { EmployersDetailLayoutCVStaff, EmployersDetailLayoutPEOStaff } from './components';
import { EmployersDetailLayoutPEOPayrollProviderStaff } from './components/EmployersDetailLayoutPEOPayrollProviderStaff';

export const EmployersDetailLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { hasPlatformRoles, hasPeoRoles, isPeoPayrollProviderUser } = useCurrentUserPermissions();

  if (hasPlatformRoles) {
    return <EmployersDetailLayoutCVStaff>{children}</EmployersDetailLayoutCVStaff>;
  }

  if (hasPeoRoles) {
    return <EmployersDetailLayoutPEOStaff>{children}</EmployersDetailLayoutPEOStaff>;
  }

  if (isPeoPayrollProviderUser) {
    return (
      <EmployersDetailLayoutPEOPayrollProviderStaff>
        {children}
      </EmployersDetailLayoutPEOPayrollProviderStaff>
    );
  }

  return <NotFoundErrorPage />;
};
